import { InfoConfirmModal } from '@/components/header';
import { Wrapper } from '@/pages/reservation/payment/styles';
import * as S from '@/pages/reservation/payment/styles';
import { PreReservationDto } from '@orcar/common';
import {
  ALERT_MESSAGE_TYPE,
  Button,
  getPreReservation,
  PAGE_NAME,
  SESSION_STORAGE_KEY,
  Styles,
  useDetectMobile,
  useGetCompanyInfo,
  useGetReservationsByUser,
} from '@orcar/common-d2c';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { CAR_SHEET_COMPANY } from '@/constants/common';
import {
  identifyUser,
  setUserProperties,
  trackReservationCreated,
} from '@/utils/analytics';

const ConfirmPaymentPage = () => {
  const navigate = useNavigate();

  const [isModalOpen, setIsModalOpen] = useState(false);

  const { isMobile, screenHeight } = useDetectMobile();
  const { data: companyData } = useGetCompanyInfo();

  // 기존 예약 목록 가져오기
  const { data: existingReservations } = useGetReservationsByUser({
    enabled: false, // 수동으로 호출
  });

  const preReservationId = sessionStorage.getItem(
    SESSION_STORAGE_KEY.PRE_RESERVATION_ID,
  );
  const [preReservationData, setPreReservationData] =
    useState<PreReservationDto>();

  const handleConfirmOrder = () => {
    navigate(
      `${PAGE_NAME.reservation_detail}/${preReservationData?.reservation?.id}`,
    );
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    if (!preReservationId) {
      alert(ALERT_MESSAGE_TYPE.NOT_ALLOWED_ACCESS);
      navigate(PAGE_NAME.index);
      return;
    }

    getPreReservation(preReservationId)
      .then((res) => {
        if (!res.reservation) {
          alert(ALERT_MESSAGE_TYPE.INVALID_RESERVATION);
          navigate(PAGE_NAME.index);
          return;
        }
        setPreReservationData(res);

        // 예약 생성 이벤트 트래킹
        trackReservationCreated({
          reservation_id: res.reservation.id,
          car_id: String(res.vehicleModelId),
          car_type: res.vehicleModel?.type || '',
          total_amount: res.price,
        });

        // 사용자 식별 및 프로퍼티 업데이트
        if (res.customerName) {
          // 기존 예약 건수 계산 (현재 예약 포함)
          const currentReservationCount =
            (existingReservations?.length || 0) + 1;

          identifyUser(res.customerName, {
            customer_name: res.customerName,
            phone_number: res.customerPhoneNumber,
            reservation_count: currentReservationCount,
            last_reservation_date: new Date().toISOString(),
            total_spent: res.price,
          });

          setUserProperties({
            has_reservation: true,
            reservation_count: currentReservationCount,
            last_reservation_date: new Date().toISOString(),
            total_spent: res.price,
          });
        }
      })
      .catch(() => {
        alert(ALERT_MESSAGE_TYPE.INVALID_RESERVATION);
        navigate(PAGE_NAME.index);
        return;
      });
  }, [preReservationId]);

  if (!preReservationData || !preReservationData?.reservation) return null;

  return (
    <Wrapper isMobile={isMobile} screenHeight={screenHeight - 148}>
      <S.Text type='main' isMobile={isMobile}>
        예약이 완료되었습니다
      </S.Text>
      <S.Text type='sub' isMobile={isMobile}>
        {`${preReservationData.customerName}님,`}
      </S.Text>
      <S.Text type='sub' isMobile={isMobile}>
        제주에서 즐거운 시간 보내세요!
      </S.Text>
      <S.Text type='number' isMobile={isMobile}>
        예약 번호: {preReservationData.reservation?.id}
      </S.Text>
      <S.ButtonWrapper isMobile={isMobile}>
        <Button
          borderRadius='5px'
          font={Styles.FONT.H4}
          width={isMobile ? '90%' : '384px'}
          height='59px'
          bgColor={Styles.COLOR.WHITE}
          color={Styles.COLOR.GREY_02}
          borderColor={Styles.COLOR.GREY_02}
          onClick={() => setIsModalOpen(true)}
        >
          유모차/카시트 대여 안내
        </Button>
        <Button
          borderRadius='5px'
          font={Styles.FONT.H4}
          width={isMobile ? '90%' : '384px'}
          height='59px'
          onClick={handleConfirmOrder}
        >
          주문 확인하기
        </Button>
      </S.ButtonWrapper>
      {isModalOpen && (
        <InfoConfirmModal
          onClose={() => setIsModalOpen(false)}
          callNumber={`예약 시 ${companyData?.name} 예약이라고 말씀해 주시면
              무료배송+요금할인이 적용됩니다!`}
        >
          <p>{`${CAR_SHEET_COMPANY.name} : ${CAR_SHEET_COMPANY.tel}`}</p>
        </InfoConfirmModal>
      )}
    </Wrapper>
  );
};

export default ConfirmPaymentPage;
